import OManageDestinationPanel from './o-manage-destination-panel-otg.vue';

export default OManageDestinationPanel;